import axios from 'axios';

// axios Api Client instance used by Orval generator for V5 API endpoints

// we need to set a base url for the api unlike the default axios instance which
// requires the engineer to add the baseUrl to api routes in the constants.js file
export const apiClientV5 = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
});
